const URL_REGEX = /\bhttps?:\/\/[^\s<>"')\]]+/gi;

// Wrap bare URLs in clickable links, skipping any text already inside an anchor.
const linkifyHtml = (html) => {
  const doc = new DOMParser().parseFromString(html, 'text/html');
  const walker = doc.createTreeWalker(doc.body, NodeFilter.SHOW_TEXT);
  const targets = [];
  while (walker.nextNode()) {
    const node = walker.currentNode;
    const insideLink = node.parentElement && node.parentElement.closest('a');
    if (node.nodeValue.includes('http') && !insideLink) {
      targets.push(node);
    }
  }

  targets.forEach((node) => {
    const text = node.nodeValue;
    const frag = doc.createDocumentFragment();
    let lastIndex = 0;
    Array.from(text.matchAll(URL_REGEX)).forEach((match) => {
      let [url] = match;
      let end = match.index + url.length;
      const trailing = url.match(/[.,;:!?]+$/);
      if (trailing) {
        url = url.slice(0, -trailing[0].length);
        end -= trailing[0].length;
      }
      if (match.index > lastIndex) {
        frag.appendChild(doc.createTextNode(text.slice(lastIndex, match.index)));
      }
      const anchor = doc.createElement('a');
      anchor.setAttribute('href', url);
      anchor.textContent = url;
      frag.appendChild(anchor);
      lastIndex = end;
    });
    if (lastIndex < text.length) {
      frag.appendChild(doc.createTextNode(text.slice(lastIndex)));
    }
    node.parentNode.replaceChild(frag, node);
  });

  return doc.body.innerHTML;
};

export default linkifyHtml;
